/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//size chart pop-up JS

let size_chart_popup = document.querySelector(".size_chart_popup");
let size_chart_popup_background = document.querySelector(".size_chart_popup_background");
let sizechart_close = document.querySelector(".sizechart_close");

// Function to disable scrolling
function disable_scroll() {
  document.body.style.overflow = "hidden"; // Disables scrolling
}

// Function to enable scrolling
function enable_scroll() {
  document.body.style.overflow = ""; // Resets to default (enables scrolling)
}

function show_sizechart_pop_up() {
  size_chart_popup_background.style.display = "block";
  size_chart_popup.style.display = "block";
  disable_scroll(); // Disable scrolling when popup opens
}

function close_sizechart_popup() {
  size_chart_popup_background.style.display = "none";
  size_chart_popup.style.display = "none";
  enable_scroll(); // Enable scrolling when popup closes
}

if(!!size_chart_popup_background){
  size_chart_popup_background.addEventListener("click", () => {
    close_sizechart_popup();
  });
}


// red menu
const desktop_menu = document.querySelectorAll('.HorizontalList__Item a');
const mobile_menu = document.querySelectorAll('.SidebarMenu__Nav .Collapsible a');

desktop_menu.forEach(item => {
  if (item.innerHTML.includes('Winter Sale')) {
    item.classList.add('red_menu_item');
  }
});
mobile_menu.forEach(item => {
  if (item.innerHTML.includes('Winter Sale')) {
    item.classList.add('red_menu_item');
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var backToTopButton = document.getElementById("back-to-top");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 200) {
      backToTopButton.classList.add("show");
    } else {
      backToTopButton.classList.remove("show");
    }
  });

  backToTopButton.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});


document.addEventListener('variant:changed', function(event) {
  let deliveryTime = document.querySelector('.ProductForm__EstimatedDelivery .time'),
      addToCart = document.querySelector('.ProductForm__AddToCart'),
      variant = event.detail.variant,
      lowStockQty = document.querySelector('.ProductForm__LowQty'),
      sku = document.querySelector('.ProductMeta__SkuNumber')

  let stockLevel = window.variantsStock[variant.id];



  if(stockLevel > 0) {
    deliveryTime.querySelector('span').innerHTML = deliveryTime.dataset.standard;
    if(addToCart.querySelector('span')){
      addToCart.querySelector('span').innerHTML = addToCart.dataset.standard;
    }
  } else {
    if(window.variantsDeliveryTimePreorder[variant.id]){
      deliveryTime.querySelector('span').innerHTML = window.variantsDeliveryTimePreorder[variant.id];
    } else {
      deliveryTime.querySelector('span').innerHTML = deliveryTime.dataset.preorder;
    }
    if(addToCart.querySelector('span')){
      addToCart.querySelector('span').innerHTML = addToCart.dataset.preorder;
    }
  }

  if(lowStockQty){
    if(stockLevel > 0 && stockLevel < 3){
      lowStockQty.querySelector('span').innerHTML = stockLevel;
      lowStockQty.style.display = 'block';
    } else {
      lowStockQty.style.display = 'none';
    }
  }

  if(sku) {
  	sku.innerHTML = variant.sku
  }
});


// Function to set the gender in localStorage based on URL
function setGenderBasedOnURL() {
  if (window.location.pathname === '/pages/herren') {
      localStorage.setItem('gender', 'men');
  } else if (window.location.pathname === '/pages/damen') {
      localStorage.setItem('gender', 'women');
  }
}

// Set gender when the page loads based on the URL
setGenderBasedOnURL();

// Add event listeners to the gender switch links
document.querySelectorAll('.gender_switch a').forEach(function(link) {
  link.addEventListener('click', function(event) {
      if (link.getAttribute('href') === '/pages/herren') {
          localStorage.setItem('gender', 'men');
      } else if (link.getAttribute('href') === '/pages/damen') {
          localStorage.setItem('gender', 'women');
      }
  });
});

document.addEventListener("DOMContentLoaded", function() {
    // Get the gender from local storage
    const gender = localStorage.getItem('gender');

    // Get the buttons by their class names
    const buttonHerren = document.querySelector('.gender_switch_button_herren');
    const buttonDamen = document.querySelector('.gender_switch_button_damen');

    // Apply styles based on the gender value
    if (gender === 'men') {
        if (buttonHerren) {
            buttonHerren.classList.add('bold-underline');
        }
        if (buttonDamen) {
            buttonDamen.classList.remove('bold-underline');
        }
    } else if (gender === 'women') {
        if (buttonDamen) {
            buttonDamen.classList.add('bold-underline');
        }
        if (buttonHerren) {
            buttonHerren.classList.remove('bold-underline');
        }
    }
});




